import { mergeClassName as e } from "../../utils/data.js";
import t from "./Row.module.js";
import { jsxDEV as n } from "react/jsx-dev-runtime";
//#region lib/components/Layout/Row.tsx
var r = "/opt/render/project/src/shared-ui/lib/components/Layout/Row.tsx";
function i({ children: i, spacing: a = 3, className: o, style: s, ref: c, ...l }) {
	return /* @__PURE__ */ n("div", {
		ref: c,
		...l,
		style: {
			gap: `var(--ag-spacing-${String(a)})`,
			...s
		},
		className: e(t.row, o),
		children: i
	}, void 0, !1, {
		fileName: r,
		lineNumber: 13,
		columnNumber: 9
	}, this);
}
//#endregion
export { i as Row };
